/**
 * Mapeo de rutas a nombres de módulos del sistema
 * Usado para verificar permisos dinámicos basados en la ruta actual
 */

export const ROUTE_TO_MODULE_MAP: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/ingredientes': 'ingredientes',
  '/recetas': 'recetas',
  '/minutas': 'minutas',
  '/pedidos': 'pedidos',
  '/compras': 'compras',
  '/proveedores': 'proveedores',
  '/lotes': 'lotes',
  '/cocina': 'cocina',
  '/reportes': 'reportes',
  '/mermas': 'mermas',
  '/clientes': 'clientes',
  '/admin': 'administracion',
  '/admin/usuarios': 'administracion',
  '/admin/roles': 'administracion',
  '/armar-pedido': 'pedidos',
};

/**
 * Obtiene el nombre del módulo basado en una ruta
 */
export const getModuleFromRoute = (path: string): string | null => {
  // Buscar coincidencia exacta
  if (ROUTE_TO_MODULE_MAP[path]) {
    return ROUTE_TO_MODULE_MAP[path];
  }

  // Buscar por prefijo (para rutas dinámicas como /pedidos/:id)
  for (const [route, module] of Object.entries(ROUTE_TO_MODULE_MAP)) {
    if (path.startsWith(route)) {
      return module;
    }
  }

  return null;
};

/**
 * Roles base del sistema (hardcodeados)
 * Estos roles NO necesitan consultar permisos dinámicos
 */
export const BASE_ROLES = [
  'administrador',
  'chef',
  'personal_cocina',
  'cliente',
];

/**
 * Verifica si un rol es un rol base o personalizado
 */
export const isBaseRole = (roleName: string): boolean => {
  return BASE_ROLES.includes(roleName.toLowerCase());
};
